module.exports = __webpack_public_path__ + "img/ask_q_preview_bg.png";